import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'CustomCard',
  props: {
  removeTopBorder: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['card', __props.removeTopBorder ? 'no-top-border' : ''])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})